module.exports = __webpack_public_path__ + "img/NEWCR3.5f32ff3d.svg";